export const isSelectedSizeUnavailable = (selectedSku, availability) => {
  if (!selectedSku || !Array.isArray(availability) || availability.length === 0) return false;
  const selectedSizeAvailability = availability.find(o => o?.sku === selectedSku);
  return (
    !selectedSizeAvailability ||
    !selectedSizeAvailability?.availableCount ||
    selectedSizeAvailability.availableCount <= 0
  );
};

export const hasNoAvailableSkus = (availabilityData, skus) => {
  if (!availabilityData?.availabilityLoaded) return false;

  if (!Array.isArray(availabilityData?.availability) || !Array.isArray(skus)) return true;

  return !skus.some(({ sku }) =>
    availabilityData?.availability.some(item => item?.sku === sku && item?.availableCount > 0)
  );
};
